module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-extension-mask.23d63d4f.png";